import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { LoadingService } from '@app/shared/services/loading.service';

@Component({
  selector: 'linqerp-loading',
  standalone: true,
  imports: [
    CommonModule,
    // MatProgressSpinner
  ],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
  private loadingService = inject(LoadingService);
  loading = this.loadingService.loading$;
}
